<template>
  <emd-text-content
    v-if="showDiscount"
    :title="$t('discount')"
  >
    <span v-if="data.discountPercentage">
      {{ data.discountPercentage + '%' }}
    </span>
    <span v-else> {{ data.discount }} </span>
  </emd-text-content>
</template>

<script>
import { EmdTextContent } from 'emerald-vue/src/components'

export default {
  name: 'DiscountPaymentLinks',

  components: {
    EmdTextContent
  },

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  computed: {
    showDiscount () {
      return this.data.discountPercentage || this.data.discount
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "discount": "Desconto"
    },
    "en-US": {
      "discount": "Discount"
    }
  }
</i18n>
